import { get } from 'lodash'
import { CONFIGURATION_TYPES } from 'constants/enums'

export default function(fields = {}, options = {}, fileUrl, sentWithId) {
  let requestBody = {}

  if (options.type === CONFIGURATION_TYPES.boolean.id) {
    requestBody = {
      booleanValue: fields.booleanValue
    }
  }

  if (options.type === CONFIGURATION_TYPES.integer.id) {
    requestBody = {
      intValue: fields.intValue
    }
  }

  if (options.type === CONFIGURATION_TYPES.decimal.id) {
    requestBody = {
      decimalValue: fields.decimalValue
    }
  }

  if (options.type === CONFIGURATION_TYPES.codeListValueTranslated.id) {
    requestBody = {
      codeListValue: {
        id: get(fields, 'codeListValueTranslated')
      }
    }
  }

  if (options.type === CONFIGURATION_TYPES.text.id) {
    requestBody = {
      textValue: fields.textValue
    }
  }

  if (options.type === CONFIGURATION_TYPES.blob.id) {
    requestBody = {
      fileUrl: fileUrl || ''
    }
  }

  if (options.type === CONFIGURATION_TYPES.textTranslated.id) {
    if (get(fields, 'configurationKey.maxNumberOfValues') > 1) {
      const sameDomainConfigs = options.configuration.allValues.filter(
        item => item.configurationKey.keyName.value === options.key
      )

      requestBody = sameDomainConfigs.map(item => ({
        translationKey: item.translationKey,
        translatedText: item.translationKey === fields.translationKey
          ? fields.translatedText
          : item.translatedText
      }))
    } else {
      requestBody = {
        translatedText: fields.translatedText,
        translationKey: fields.translationKey
      }
    }
  }

  const isArray = Array.isArray(requestBody)

  if (sentWithId) {
    if (isArray) {
      requestBody.map(item => ({
        item,
        id: get(fields, 'id')
      }))
    } else {
      requestBody = {
        ...requestBody,
        id: get(fields, 'id')
      }
    }
  }

  return {
    array: isArray ? requestBody : [requestBody]
  }
}
